import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import { Trash } from 'react-feather';

const SparepartImportItemForm = ({
    item,
    index,
    sparePartOptions,
    onChange,
    onRemove
}) => {
    // Find the selected spare part from sparePartOptions to get its unit
    // Handle both string and number spare_part_id values
    const selectedSparePart = sparePartOptions?.find(option => 
        option.value === item.spare_part_id || 
        option.value === Number(item.spare_part_id) ||
        String(option.value) === String(item.spare_part_id)
    );
    const unitName = selectedSparePart?.unit?.name || '';
    const unitSymbol = selectedSparePart?.unit?.symbol || '';
    
    const totalPrice = (parseFloat(item.quantity) || 0) * (parseFloat(item.price) || 0);

    return (
        <div className="border rounded p-3 mb-3 position-relative">
            <div className="row">
                <div className="col-md-3">
                    <Form.Group className="mb-3">
                        <Form.Label>Ehtiyot qism</Form.Label>
                        <Select
                            value={sparePartOptions.find(option => option.value === Number(item.spare_part_id) || option.value === item.spare_part_id)}
                            onChange={(selected) => onChange(index, 'spare_part_id', selected.value)}
                            options={sparePartOptions}
                            placeholder="Ehtiyot qismni tanlang..."
                            isSearchable={true}
                        />
                    </Form.Group>
                </div>
                <div className="col-md-2">
                    <Form.Group className="mb-3">
                        <Form.Label>Miqdori</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="number"
                                placeholder="Miqdorni kiriting"
                                value={item.quantity}
                                onChange={(e) => onChange(index, 'quantity', e.target.value)}
                                required
                            />
                            {unitName && (
                                <InputGroup.Text>
                                    {unitSymbol || unitName}
                                </InputGroup.Text>
                            )}
                        </InputGroup>
                    </Form.Group>
                </div>
                <div className="col-md-2">
                    <Form.Group className="mb-3">
                        <Form.Label>Narxi</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Narxni kiriting"
                            value={item.price}
                            onChange={(e) => onChange(index, 'price', e.target.value)}
                            required
                        />
                    </Form.Group>
                </div>
                <div className="col-md-3 d-flex align-items-end">
                    <Form.Group className="mb-3 w-100">
                        <Form.Label>Jami</Form.Label>
                        <Form.Control
                            type="text"
                            value={totalPrice ? totalPrice.toLocaleString('uz-UZ') : '0'}
                            readOnly
                            className="fw-bold text-primary bg-light"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <Button 
                        variant="outline-danger" 
                        className="mb-3"
                        onClick={() => onRemove(index)}
                    >
                        <Trash size={16} />
                    </Button>
                </div>
            </div>
        </div>
    );
};

SparepartImportItemForm.propTypes = {
    item: PropTypes.shape({
        spare_part_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        price: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }).isRequired,
    index: PropTypes.number.isRequired,
    sparePartOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
        unit: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            symbol: PropTypes.string
        })
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
};

export default SparepartImportItemForm; 